export default function slideMenu() {


    const slideMenuBtns = document.querySelectorAll('.js-new-slide-menu-btn');
    const slideMenu = document.querySelector('.js-new-slide-menu');
    const slideMenuBack = document.querySelectorAll('.js-new-slide-menu-back');

    if ( slideMenuBtns.length && slideMenu ) {
        for (let btn of slideMenuBtns ) {
            btn.addEventListener('click',function(){
                document.querySelector(`.js-new-slide-menu[data-index="${btn.dataset.index}"]`)?.classList.add("header-mobile__slide-menu_open")
                // slideMenu.classList.add("header-mobile__slide-menu_open");
            });
        }
    }

    if ( slideMenuBack && slideMenu ) {
        slideMenuBack.forEach(btn => {
            btn.addEventListener('click',function(){
                btn.closest('.js-new-slide-menu')?.classList.remove("header-mobile__slide-menu_open");
            });
        })

    }

}
